<div class="d-inline" tooltipClass="bubble-tooltip" placement="{{ tooltipPosition }}" ngbTooltip="{{ bubbleContent }}" (shown)="onTooltipShown()">
<span class="bubble" [ngClass]="{'disable-ripple': isHovered}"></span>
</div>
